import { Protocol } from '../Protocol';

export class QrcodeProtocol {
  public static readonly QRCODE_DATA: string = `${Protocol.YATUNG_API_ROOT}/expt/qr`;
  public static readonly IS_VALID_ORDER_BY_QRCODE: string = `${Protocol.YATUNG_API_ROOT}/expt/qr/check`;
  public static readonly IS_VALID_CHEM_ADMX_BY_SPECIMEN: string = `${Protocol.YATUNG_API_ROOT}/expt/qr/check/chem`;
}
